import { serviceQueries } from '@estee/elc-service-bus';
import { ICart } from './ICartAPIs';
import { makeQuery } from '~api/ServiceQueries/MakeQuery';

//@ts-ignore
export const getCart = (): Promise<ICart> =>
    makeQuery(serviceQueries.GET_CART, { asPlainText: true });

export const getCartSamples = async () =>
    (await getCart()).cartItems?.filter(({ product }) => product.isSample);
